import { generateId } from '@freelancer/datastore/testing/helpers';
import type { SearchArticle } from './search-articles.model';

export interface GenerateSearchArticleOptions {
  readonly id?: number;
  readonly title?: string;
  readonly categoryName?: string;
  readonly canonicalUrl?: string;
  readonly seoUrl?: string;
}

export function generateSearchArticleObject({
  id = generateId(),
  title,
  canonicalUrl,
  categoryName = 'General',
  seoUrl,
}: GenerateSearchArticleOptions): SearchArticle {
  return {
    id,
    title: title ?? `Article ${id}`,
    canonicalUrl: canonicalUrl
      ? // Copied from transformSearchArticle
        canonicalUrl.replace(/^\//, '').split('/').length === 4
        ? canonicalUrl
        : `/support/employer/${categoryName.toLowerCase()}/${seoUrl ?? `article-${id}`}`
      : `/support/employer/general/article-${id}`,
  };
}

export function generateSearchArticleObjects(
  articles: readonly GenerateSearchArticleOptions[],
): readonly SearchArticle[] {
  return articles.map(article => generateSearchArticleObject(article));
}
